import {eventService} from "../../services/Events.service";
import './TextButton.scss'

interface TextButtonProps {
    text: string;
    isActive: boolean;
}

const TextButton: React.FC<TextButtonProps> = ({ text, isActive }) => {
    return (
        <div className={`text_button_wrapper ${isActive ? "active" : ""}`}>
            <button onClick={() => eventService.sendClick(text)}>{text}</button>
        </div>
    );
};
export default TextButton;